var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"member"}},[_c('PopUpWin',{attrs:{"isPop":_vm.isShow,"tipWord":_vm.tips,"codeUrl":_vm.url},on:{"update:isPop":function($event){_vm.isShow=$event},"update:is-pop":function($event){_vm.isShow=$event},"closePop":function($event){_vm.isShow=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }